export default __webpack_public_path__ + "static/media/smallIntermission2.63630912.mp3";